<div class="stage container">
    <div class="confirmation-status group">
        <div class="confirmation-status-message">
            <h1>Your password has been changed.</h1>
            <p>Click the Ok button to return to the login page.</p>
            <button mat-raised-button type="button" class="btn btn-primary" (click)="successAndReturn()">Ok</button>
        </div>
    </div>
</div>
